import { VehicleWizardStepText } from "./types";

/** Naslov i objašnjenje ispod scene — što se u kojem koraku radi. */
export const VEHICLE_WIZARD_INTRO_TEXTS: Record<string, VehicleWizardStepText> = {
  picker: {
    title: "Odaberite vozilo",
    description: "Izaberite proizvođača, model i tip. Tehnički podaci se popune sami.",
  },
  info: {
    title: "Osnovne informacije",
    description: "Upišite VIN, registraciju i kilometražu. Obavezna polja su označena zvjezdicom.",
  },
  tires: {
    title: "Gume",
    description: "Dodajte gume na osovine. Pratimo dubinu profila i podsjetimo vas na zamjenu.",
  },
  location: {
    title: "Lokacija",
    description: "Odredite poslovnicu ili skladište gdje vozilo stoji.",
  },
  equipment: {
    title: "Oprema",
    description: "Označite opremu vozila. Ona se prenosi u oglas i ponudu.",
  },
  extinguisher: {
    title: "PP aparat",
    description: "Unesite vatrogasni aparat i rok valjanosti. Podsjetnik stiže prije isteka.",
  },
  owner: {
    title: "Vlasnik",
    description: "Tko je vlasnik vozila: tvrtka, leasing ili drugi kontakt.",
  },
  price: {
    title: "Cijena",
    description: "Nabavna i prodajna cijena. Iz njih nastaju ponude i računi.",
  },
  pictures: {
    title: "Slike",
    description: "Dodajte fotografije vozila i odaberite naslovnu.",
  },
  documents: {
    title: "Dokumenti",
    description: "Prometna, polica i ostali dokumenti vozila na jednom mjestu.",
  },
};

/** Fotografija vozila dok korisnik ne odabere tip s vlastitom slikom. */
export const VEHICLE_WIZARD_DEFAULT_IMAGE = "/media/images/vehicles/vehicle-2.png";

/** Primjeri koji se prikazuju dok podatak još nije upisan. */
export const VEHICLE_WIZARD_SAMPLE = {
  name: "Kia Sorento",
  type: "1.6 T-GDI HEV",
  plate: "ZG 1234 AB",
  vin: "KNAPU81ABP7123456",
  km: 84320,
  fuel: "Hibrid",
  transmission: "Automatski",
  powerKw: 169,
  powerHp: 230,
  tireDimensions: "235/60 R18",
  tireManufacturer: "Michelin",
  tireType: "Ljetne",
  profileDepth: 6.5,
  equipment: ["Klima uređaj", "Navigacija", "Parking senzori", "Kamera za vožnju unatrag"],
  extinguisherName: "PP aparat S6",
  extinguisherSerial: "SN 204 118",
  ownerName: "Orytron d.o.o.",
  ownerType: "Vlasništvo",
  netPrice: 38500,
  specialTax: 2150,
  sellingPrice: 45900,
  pictures: [
    "/media/images/vehicles/vehicle-2.png",
    "/media/images/vehicles/vehicle-3.png",
    "/media/images/vehicles/vehicle-4.png",
    "/media/images/vehicles/vehicle-8.png",
  ],
  documents: ["Prometna dozvola", "Polica osiguranja", "Servisna knjižica"],
};
